export default __webpack_public_path__ + "static/media/3stepweightloss_1@2x.4549a63e.jpg";